(() => {
  'use strict';

  const STORAGE_KEY = 'minion.species.v1';
  document.querySelectorAll('[data-minion-storefront]').forEach(initStorefront);
  document.querySelectorAll('[data-minion-product]').forEach(initProduct);
  document.querySelectorAll('[data-mn-stage-fit]').forEach((finder) => {
    finder.querySelectorAll('[data-mn-fit-choice]').forEach((button) => button.addEventListener('click', () => {
      const group = button.closest('fieldset');
      group?.querySelectorAll('[data-mn-fit-choice]').forEach((choice) => choice.classList.toggle('is-active', choice === button));
    }));
  });

  function applyPdpSpecies(value) {
    if (value !== 'dog' && value !== 'cat') return;
    document.documentElement.dataset.minionSpecies = value;
    document.querySelectorAll('[data-mn-species-content]').forEach((panel) => {
      panel.hidden = panel.dataset.mnSpeciesContent !== value;
    });
  }

  function initStorefront(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const q = (selector, scope = root) => scope.querySelector(selector);
    const qa = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));
    const onboarding = q('[data-mn-onboarding]');
    const store = q('[data-mn-store]');
    const currency = root.dataset.currency || 'USD';
    let species = null;

    function rememberedSpecies() {
      const queryValue = new URLSearchParams(location.search).get('species');
      if (queryValue === 'dog' || queryValue === 'cat') return queryValue;
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        return saved === 'dog' || saved === 'cat' ? saved : null;
      } catch (_) { return null; }
    }

    function persistSpecies(value) {
      try { localStorage.setItem(STORAGE_KEY, value); } catch (_) {}
      document.cookie = `minion_species=${value}; path=/; max-age=31536000; SameSite=Lax`;
    }

    function showOnboarding() {
      onboarding.hidden = false;
      store.hidden = true;
      document.documentElement.classList.add('mn-species-gate-open');
    }

    function selectSpecies(value, persist = true) {
      if (value !== 'dog' && value !== 'cat') return;
      species = value;
      if (persist) persistSpecies(value);
      document.documentElement.dataset.minionSpecies = value;
      qa('[data-mn-species-panel]').forEach((panel) => { panel.hidden = panel.dataset.mnSpeciesPanel !== value; });
      qa('[data-mn-species-label]').forEach((label) => { label.textContent = value.toUpperCase(); });
      onboarding.hidden = true;
      store.hidden = false;
      document.documentElement.classList.remove('mn-species-gate-open');
      root.dispatchEvent(new CustomEvent('minion:species-change', { bubbles: true, detail: { species: value } }));
    }

    function activePanel() { return q(`[data-mn-species-panel="${species}"]`); }

    function applyProductPreference(value) {
      const panel = activePanel();
      if (!panel) return;
      const normalized = String(value || '').toLowerCase();
      const cards = qa('[data-mn-product-card]', panel);
      let matches = 0;
      cards.forEach((card) => {
        const haystack = `${card.dataset.sizes || ''},${card.dataset.intents || ''},${card.dataset.categories || ''}`;
        const match = haystack.includes(normalized);
        card.classList.toggle('is-recommended', match);
        card.classList.toggle('is-muted', !match);
        if (match) matches += 1;
      });
      const message = q('[data-mn-recommendation]', panel);
      if (message) {
        message.hidden = false;
        q('[data-mn-recommendation-title]', message).textContent = `${String(value).toUpperCase()} EDIT`;
        q('[data-mn-recommendation-copy]', message).textContent = matches
          ? `${matches} relevant product${matches === 1 ? '' : 's'} moved to the front.`
          : 'We kept the full edit visible so you can compare every option.';
      }
      q('[data-mn-anchor="shop"]', panel)?.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }

    function initFilters() {
      qa('[data-mn-fit-filter]').forEach((group) => {
        group.addEventListener('click', (event) => {
          const button = event.target.closest('[data-filter-value]');
          if (!button) return;
          qa('[data-filter-value]', group).forEach((item) => item.classList.toggle('is-active', item === button));
          applyProductPreference(button.dataset.filterValue);
        });
      });
      qa('[data-mn-intent]').forEach((button) => button.addEventListener('click', () => applyProductPreference(button.dataset.mnIntent)));
      qa('[data-mn-ugc-filter]').forEach((group) => {
        group.addEventListener('click', (event) => {
          const button = event.target.closest('[data-filter-value]');
          if (!button) return;
          const value = button.dataset.filterValue || 'all';
          qa('[data-filter-value]', group).forEach((item) => item.classList.toggle('is-active', item === button));
          const panel = button.closest('[data-mn-species-panel]');
          qa('[data-mn-ugc]', panel).forEach((card) => card.classList.toggle('is-hidden', value !== 'all' && !(card.dataset.tags || '').includes(value)));
        });
      });
    }

    async function addItems(items) {
      if (!items.length || items.some((item) => !item.id)) throw new Error('This product is not mapped yet.');
      const response = await fetch(root.dataset.cartUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || 'Could not add this to your bag.');
      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        qa('[data-mn-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return payload;
    }

    function toast(message) {
      const node = q('[data-mn-toast]');
      node.textContent = message;
      node.hidden = false;
      clearTimeout(toast.timer);
      toast.timer = setTimeout(() => { node.hidden = true; }, 2600);
    }

    function initQuickAdd() {
      qa('[data-mn-quick-add]').forEach((button) => button.addEventListener('click', async () => {
        button.disabled = true;
        try {
          await addItems([{ id: button.dataset.variantId, quantity: 1 }]);
          toast('Added to bag.');
        } catch (error) { toast(error.message); }
        finally { button.disabled = false; }
      }));
    }

    function initKits() {
      qa('[data-mn-kit]').forEach((kit) => {
        const addButton = q('[data-mn-add-kit]', kit);
        const addons = qa('[data-mn-kit-addon]', kit).filter((button) => button.dataset.variantId);
        const update = () => {
          const total = Number(addButton?.dataset.anchorPrice || 0) + addons.reduce((sum, button) => button.getAttribute('aria-pressed') === 'true' ? sum + Number(button.dataset.price || 0) : sum, 0);
          const totalNode = q('[data-mn-kit-total]', kit);
          if (totalNode && total) totalNode.textContent = money(total, currency);
          const count = addons.filter((button) => button.getAttribute('aria-pressed') === 'true').length;
          const savings = q('[data-mn-kit-savings]', kit);
          if (savings) savings.textContent = count ? `${count} ADD-ON${count === 1 ? '' : 'S'} SELECTED` : '';
        };
        addons.forEach((button) => button.addEventListener('click', () => {
          const selected = button.getAttribute('aria-pressed') === 'true';
          button.setAttribute('aria-pressed', String(!selected));
          update();
        }));
        addButton?.addEventListener('click', async () => {
          const items = [{ id: addButton.dataset.anchorVariant, quantity: 1 }, ...addons
            .filter((button) => button.getAttribute('aria-pressed') === 'true')
            .map((button) => ({ id: button.dataset.variantId, quantity: 1 }))];
          addButton.disabled = true;
          try { await addItems(items); toast(`${items.length} item${items.length === 1 ? '' : 's'} added to bag.`); }
          catch (error) { toast(error.message); }
          finally { addButton.disabled = false; }
        });
        update();
      });
    }

    qa('[data-mn-choose-species]').forEach((button) => button.addEventListener('click', () => selectSpecies(button.dataset.mnChooseSpecies)));
    qa('[data-mn-change-species]').forEach((button) => button.addEventListener('click', showOnboarding));
    q('[data-mn-menu]')?.addEventListener('click', () => q('[data-mn-nav]')?.classList.toggle('is-open'));
    qa('[data-mn-scroll]').forEach((button) => button.addEventListener('click', () => q(`[data-mn-anchor="${button.dataset.mnScroll}"]`, activePanel())?.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth' })));
    initFilters();
    initQuickAdd();
    initKits();

    const initialSpecies = rememberedSpecies();
    if (initialSpecies) selectSpecies(initialSpecies, false);
    else showOnboarding();
  }

  function initProduct(root) {
    if (root.dataset.productInitialized === 'true') return;
    root.dataset.productInitialized = 'true';
    const q = (selector, scope = root) => scope.querySelector(selector);
    const qa = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));
    const currency = root.dataset.currency || 'USD';
    const gate = q('[data-mn-pdp-gate]');
    const currentSpecies = root.dataset.species;

    function rememberedSpecies() {
      const queryValue = new URLSearchParams(location.search).get('species');
      if (queryValue === 'dog' || queryValue === 'cat') return queryValue;
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        return saved === 'dog' || saved === 'cat' ? saved : null;
      } catch (_) { return null; }
    }

    function persistSpecies(value) {
      try { localStorage.setItem(STORAGE_KEY, value); } catch (_) {}
      document.cookie = `minion_species=${value}; path=/; max-age=31536000; SameSite=Lax`;
    }

    function showSpeciesGate() {
      if (!gate) return;
      gate.hidden = false;
      document.documentElement.classList.add('mn-species-gate-open');
    }

    function hideSpeciesGate() {
      if (!gate) return;
      gate.hidden = true;
      document.documentElement.classList.remove('mn-species-gate-open');
    }

    qa('[data-mn-pdp-species-choice]').forEach((choice) => choice.addEventListener('click', (event) => {
      event.preventDefault();
      const value = choice.dataset.mnPdpSpeciesChoice;
      if (value !== 'dog' && value !== 'cat') return;
      persistSpecies(value);
      applyPdpSpecies(value);
      const productUrl = choice.dataset.productUrl;
      if (value === currentSpecies || !productUrl) {
        hideSpeciesGate();
        return;
      }
      const destination = new URL(productUrl, location.origin);
      destination.searchParams.set('species', value);
      location.assign(destination.toString());
    }));
    q('[data-mn-pdp-change-species]')?.addEventListener('click', showSpeciesGate);

    applyPdpSpecies(currentSpecies);
    if (rememberedSpecies()) hideSpeciesGate();
    else showSpeciesGate();

    let product = null;
    try { product = JSON.parse(q('[data-mn-product-json]')?.textContent || 'null'); }
    catch (_) { showToast('Product data could not be loaded.'); }
    if (!product) return;
    const optionGroups = qa('[data-option-position]');
    let currentVariant = product.variants?.find((variant) => String(variant.id) === String(product.selectedVariantId))
      || product.variants?.find((variant) => variant.available)
      || product.variants?.[0];
    let quantity = 1;

    function selectedOptions() {
      return optionGroups.map((group) => q('[data-mn-option-value].is-active', group)?.dataset.mnOptionValue || '');
    }

    function findVariant() {
      const selections = selectedOptions();
      return product.variants.find((variant) => {
        const options = Array.isArray(variant.options)
          ? variant.options
          : [variant.option1, variant.option2, variant.option3].filter(Boolean);
        return selections.every((value, index) => options[index] === value);
      });
    }

    function variantPrice(variant) { return Number(variant?.price || 0); }
    function comparePrice(variant) { return Number(variant?.compare_at_price || 0); }

    function showGalleryMedia(mediaId, source, alt) {
      if (!source) return;
      const hero = q('[data-mn-gallery-hero]');
      const image = q('[data-mn-gallery-hero] img');
      if (!hero || !image) return;
      const normalizedMediaId = String(mediaId || '');
      const currentSource = image.currentSrc || image.src;
      if (currentSource !== source) {
        hero.classList.add('is-changing');
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = source;
        if (alt) image.alt = alt;
        window.setTimeout(() => hero.classList.remove('is-changing'), reducedMotion() ? 0 : 180);
      }
      if (normalizedMediaId) hero.dataset.mediaId = normalizedMediaId;
      const thumbs = qa('[data-mn-gallery-thumb]');
      let activeIndex = -1;
      thumbs.forEach((thumb, index) => {
        const active = String(thumb.dataset.mediaId) === normalizedMediaId;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
        if (active) activeIndex = index;
      });
      if (activeIndex >= 0) {
        const counter = q('[data-mn-gallery-index]');
        if (counter) counter.textContent = String(activeIndex + 1);
        thumbs[activeIndex].scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    qa('[data-mn-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      showGalleryMedia(thumb.dataset.mediaId, thumb.dataset.imageSrc, thumb.dataset.imageAlt);
    }));

    function showVariantMedia(variant) {
      const colorIndex = optionGroups.findIndex((group) => ['color', 'colour'].includes(String(group.dataset.optionName || '').toLowerCase()));
      const options = Array.isArray(variant?.options)
        ? variant.options
        : [variant?.option1, variant?.option2, variant?.option3].filter(Boolean);
      const color = colorIndex >= 0 ? String(options[colorIndex] || '') : '';
      const colorThumb = qa('[data-mn-gallery-thumb][data-variant-color]').find((thumb) => (
        String(thumb.dataset.variantColor || '').trim().toLowerCase() === color.trim().toLowerCase()
      ));
      if (colorThumb) {
        showGalleryMedia(colorThumb.dataset.mediaId, colorThumb.dataset.imageSrc, colorThumb.dataset.imageAlt);
        return;
      }
      if (variant?.featured_image?.src) {
        showGalleryMedia(variant.featured_media_id, variant.featured_image.src, variant.featured_image.alt);
      }
    }

    function updateOptionAvailability() {
      const selections = selectedOptions();
      optionGroups.forEach((group, groupIndex) => {
        qa('[data-mn-option-value]', group).forEach((button) => {
          const candidate = [...selections];
          candidate[groupIndex] = button.dataset.mnOptionValue || '';
          const possible = product.variants.some((variant) => {
            const options = Array.isArray(variant.options)
              ? variant.options
              : [variant.option1, variant.option2, variant.option3].filter(Boolean);
            return variant.available && candidate.every((value, index) => !value || options[index] === value);
          });
          button.disabled = !possible;
          button.classList.toggle('is-unavailable', !possible);
        });
      });
    }

    function updateVariant(variant, syncMedia = false) {
      currentVariant = variant;
      const price = variantPrice(variant);
      const compare = comparePrice(variant);
      q('[data-mn-price]').textContent = money(price, currency);
      q('[data-mn-one-price]').textContent = money(price, currency);
      q('[data-mn-two-price]').textContent = money(price * 2, currency);
      q('[data-mn-atc-price]').textContent = money(price * quantity, currency);
      q('[data-mn-sticky-price]').textContent = money(price * quantity, currency);
      const compareNode = q('[data-mn-compare]');
      const savingNode = q('[data-mn-savings]');
      compareNode.hidden = !(compare > price);
      savingNode.hidden = !(compare > price);
      if (compare > price) {
        compareNode.textContent = money(compare, currency);
        savingNode.textContent = `SAVE ${money(compare - price, currency)}`;
      }
      const available = Boolean(variant?.available);
      const atc = q('[data-mn-main-atc]');
      atc.dataset.variantId = variant?.id || '';
      atc.disabled = !available;
      q('[data-mn-atc-label]').textContent = available ? 'CHECKOUT NOW' : 'SOLD OUT';
      q('[data-mn-sticky-variant]').textContent = variant?.title || '';
      q('[data-mn-sticky-button]').disabled = !available;
      const variantInput = q('[data-mn-variant-input]');
      if (variantInput) variantInput.value = variant?.id || '';

      if (syncMedia) showVariantMedia(variant);
      updateOptionAvailability();
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }

    optionGroups.forEach((group) => group.addEventListener('click', (event) => {
      const button = event.target.closest('[data-mn-option-value]');
      if (!button) return;
      qa('[data-mn-option-value]', group).forEach((choice) => {
        const active = choice === button;
        choice.classList.toggle('is-active', active);
        choice.setAttribute('aria-pressed', String(active));
      });
      q('[data-mn-option-label]', group).textContent = button.dataset.mnOptionValue;
      const variant = findVariant();
      const isColor = ['color', 'colour'].includes(String(group.dataset.optionName || '').toLowerCase());
      if (variant) updateVariant(variant, isColor);
    }));

    qa('[data-mn-pet-weight]').forEach((button) => button.addEventListener('click', () => {
      qa('[data-mn-pet-weight]').forEach((choice) => {
        const active = choice === button;
        choice.classList.toggle('is-active', active);
        choice.setAttribute('aria-pressed', String(active));
      });
      const result = q('[data-mn-fit-result]');
      result.hidden = false;
      const weight = button.dataset.mnPetWeight || '';
      const title = q('[data-mn-fit-title]');
      const copy = q('[data-mn-fit-copy]');
      if (title) title.textContent = `${weight} — PERFECT FIT`;
      copy.textContent = currentSpecies === 'dog'
        ? 'The roomy dog pouch works across the listed weight ranges. Choose your normal human size for the intended oversized hoodie fit.'
        : 'The flexible cat pouch works across the listed weight ranges. Choose your normal human size for the intended oversized hoodie fit.';
    }));

    qa('[data-mn-bundle] button').forEach((button) => button.addEventListener('click', () => {
      quantity = Number(button.dataset.quantity || 1);
      qa('[data-mn-bundle] button').forEach((choice) => {
        const active = choice === button;
        choice.classList.toggle('is-active', active);
        choice.setAttribute('aria-pressed', String(active));
      });
      updateVariant(currentVariant, false);
    }));

    async function add(items) {
      const response = await fetch(root.dataset.cartUrl || '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }),
      });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.description || 'Could not add this to your bag.');
      const cartResponse = await fetch('/cart.js');
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        qa('[data-mn-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    async function addCurrent(button) {
      if (!currentVariant?.id) return;
      button.disabled = true;
      try {
        await add([{ id: String(currentVariant.id), quantity }]);
        location.assign(root.dataset.checkoutUrl || '/checkout');
      }
      catch (error) { showToast(error.message); }
      finally { button.disabled = !currentVariant.available; }
    }

    const mainAtc = q('[data-mn-main-atc]');
    mainAtc?.addEventListener('click', () => addCurrent(mainAtc));
    q('[data-mn-sticky-button]')?.addEventListener('click', (event) => addCurrent(event.currentTarget));
    qa('[data-mn-cross-add]').forEach((button) => button.addEventListener('click', async () => {
      button.disabled = true;
      try { await add([{ id: button.dataset.variantId, quantity: 1 }]); showToast('Added to bag.'); }
      catch (error) { showToast(error.message); }
      finally { button.disabled = false; }
    }));

    const sticky = q('[data-mn-sticky-atc]');
    if (mainAtc && sticky && matchMedia('(max-width: 760px)').matches) {
      const observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting; }, { threshold: .05 });
      observer.observe(mainAtc);
    }
    if (currentVariant) updateVariant(currentVariant, true);

    function showToast(message) {
      const node = q('[data-mn-toast]');
      if (!node) return;
      node.textContent = message;
      node.hidden = false;
      clearTimeout(showToast.timer);
      showToast.timer = setTimeout(() => { node.hidden = true; }, 2600);
    }
  }

  function money(cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format((Number(cents) || 0) / 100); }
    catch (_) { return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`; }
  }
  function reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
})();
